export function toCamelCase(str) {
    if (!/^[A-Z]/.test(str) && str.split(" ").length <= 1) {
        return str
    }
    return str
      .toLowerCase()
      .replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
  }